import { useApyBreakdownTooltipData } from 'src/hooks/useApyBreakdownTooltipData';
import ApyBreakdownTooltipV2 from 'src/components/Tooltip/ApyBreakdownTooltipV2';
import MarketIcon from 'src/components/Utils/MarketIcon';
import NumberDisplay from 'src/components/NumberDisplay/NumberDisplay';
import Tooltip from 'src/components/primitives/Tooltip/Tooltip';
import { cj } from 'src/utils/classNames';
import { PRESETS } from 'src/utils/formatNumber/presets';

export const EarnApy = ({
	selectedMarketIndex,
	marketDisplaySymbol,
}: {
	selectedMarketIndex: number;
	marketDisplaySymbol: string;
}) => {
	const apyData = useApyBreakdownTooltipData(selectedMarketIndex);

	return (
		<div className="flex items-center justify-between">
			<div className="flex items-center gap-xs text-text-secondary">
				<Tooltip
					className="typo-body-xs"
					content="Deposited assets automatically earn yields."
				>
					Earning APY
				</Tooltip>
			</div>
			<div className="flex items-center gap-sm">
				<div className="flex items-center gap-xs">
					<MarketIcon
						marketSymbol={marketDisplaySymbol}
						sizeClass="w-4 h-4"
						className="shrink-0"
					/>
					<span className="typo-label-xs text-text-default">
						{marketDisplaySymbol}
					</span>
				</div>
				<div className="flex items-center gap-sm">
					<ApyBreakdownTooltipV2
						apyChunks={apyData.deposit.chunks}
						showTooltip={apyData.deposit.showTooltip}
					>
						<div className="flex items-center gap-xs">
							<NumberDisplay
								value={apyData.deposit.totalApyBN}
								options={PRESETS.percentTruncateTrim}
								className={cj(
									'typo-label-xs',
									apyData.deposit.totalApy > 0.009
										? 'text-text-positive-green-button'
										: 'text-text-secondary'
								)}
							/>
						</div>
					</ApyBreakdownTooltipV2>
				</div>
			</div>
		</div>
	);
};
